import React from 'react';
import PropTypes from 'prop-types';
import { Add as ExpandIcon, Clear as CollapseIcon } from '@material-ui/icons';
import MaterialTextField from 'shared/components/connectedTextField/c/materialTextField/MaterialTextField';
import MaterialNumberField from 'shared/components/connectedTextField/c/materialNumberField/MaterialNumberField';
import SovosDatePicker from 's1-ui/sovos-datepicker/SovosDatePicker';
import { STRING, NUMBER, DATE } from 'shared/constants/InvoiceFiltersTypes';
import { materialRed } from 'theme/mainColors';

const FilterItem = ({
  filter,
  onExpand,
  onCollapse,
  onFieldChange,
  onFieldBlur
}) => (
  <div className="filter-item__container">
    <div
      className="filter-item__title"
      onClick={ onExpand }
      style={ { cursor: filter.collapsed ? 'pointer' : '' } }
    >
      <div>{filter.title}</div>
      {filter.collapsed && <ExpandIcon color="secondary" />}
    </div>

    <div className="filter-item__inputs">
      {filter.data.type === STRING && !filter.collapsed && (
        <MaterialTextField
          name={ filter.data.key }
          style={ { marginRight: 15 } }
          value={ filter.data.value }
          onChange={ onFieldChange }
        />
      )}
      {filter.data.type === DATE && !filter.collapsed && (
        <SovosDatePicker
          name={ filter.data.key }
          onChange={ onFieldChange }
          value={ filter.data.value || null }
          format="MM-DD-YYYY"
          style={ { margin: '7px 15px 8px 0px', fontSize: 15 } }
          disabled={ filter.disabled }
        />
      )}
      {filter.data.type === NUMBER && !filter.collapsed && (
        <MaterialNumberField
          name={ filter.data.min.key }
          style={ { marginRight: 15 } }
          hintText={ 'Min' }
          value={ filter.data.min.value }
          onChange={ onFieldChange }
          allowNegative={ filter.data.min.allowNegative }
          onBlur={ onFieldBlur }
        />
      )}
      {filter.data.type === NUMBER && !filter.collapsed && (
        <MaterialNumberField
          name={ filter.data.max.key }
          style={ { marginRight: 15 } }
          hintText={ 'Max' }
          value={ filter.data.max.value }
          onChange={ onFieldChange }
          allowNegative={ filter.data.max.allowNegative }
          onBlur={ onFieldBlur }
        />
      )}
      {!filter.collapsed && (
        <CollapseIcon
          color="secondary"
          style={ {
            cursor: 'pointer',
            fontSize: 18,
            marginTop: 18,
            marginRight: 4
          } }
          onClick={ onCollapse }
        />
      )}
    </div>
    {!filter.collapsed && (
      <div style={ { fontSize: 12, color: materialRed } }>
        {filter.filterValidationError}
      </div>
    )}
    <hr />
  </div>
);

FilterItem.propTypes = {
  filter: PropTypes.object.isRequired,
  onExpand: PropTypes.func.isRequired,
  onCollapse: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFieldBlur: PropTypes.func
};

export default FilterItem;



// WEBPACK FOOTER //
// ./src/shared/components/filterItem/FilterItem.js